import script from "./ArticlePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePage.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePage.vue?vue&type=style&index=0&id=6b472354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b472354"]])

export default __exports__